import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'app-bigcommerce-installation-guide',
	templateUrl: './bigcommerce-installation-guide.component.html',
	styleUrls: ['./bigcommerce-installation-guide.component.scss'],
	imports: [MatIcon, MatDialogClose]
})
export class BigcommerceInstallationGuideComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
